module.exports = __webpack_public_path__ + "img/warning.9b4532df.svg";